"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFeaturesConfig = exports.createAgencyConfig = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const bookings_partial_1 = require("./bookings-partial");
const ebts_partial_1 = require("./ebts-partial");
const lineups_partial_1 = require("./lineups-partial");
const oidc_partial_1 = require("./oidc-partial");
function createAgencyConfig(config) {
    // merge the default config with the provided values
    const result = merge_1.default({}, config, {
        features: createFeaturesConfig(config.features)
    });
    // these need to be manually set since we want the provided JFD/JFL instances,
    // not merge the default one
    result.jfd = config.jfd;
    result.bookingJFL = config.bookingJFL;
    return result;
}
exports.createAgencyConfig = createAgencyConfig;
const defaultFeaturesConfig = {
    backgroundChecks: false,
    mugshotMinHeight: 600,
    mugshotMinWidth: 480,
    smtPhotoMinHeight: 1000,
    smtPhotoMinWidth: 1000,
    audits: {
        subjectNameFormat: '<First Name> <Middle Name (optional)> <LastName>'
    }
};
function createFeaturesConfig(config) {
    var _a, _b, _c, _d;
    // merge the default config with the provided values
    return merge_1.default({}, defaultFeaturesConfig, config, {
        bookings: bookings_partial_1.createBookingsConfig((_a = config.bookings) !== null && _a !== void 0 ? _a : {}),
        lineups: lineups_partial_1.createLineupsConfig((_b = config.lineups) !== null && _b !== void 0 ? _b : {}),
        ebts: ebts_partial_1.createEbtsConfig((_c = config.ebts) !== null && _c !== void 0 ? _c : {}),
        oidc: oidc_partial_1.createOidcConfig((_d = config.oidc) !== null && _d !== void 0 ? _d : {})
    });
}
exports.createFeaturesConfig = createFeaturesConfig;
//# sourceMappingURL=agency-config-partial.js.map